import React from 'react';
import { About } from '../components/About';
import { Instagram } from '../components/Instagram';

export default function AboutPage() {
  return (
    <div className="pt-24">
      <About />
      <Instagram />
    </div>
  );
}